var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mail",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8108",
    "data-name": "Rectangle 8108",
    width: 24,
    height: 24,
    transform: "translate(316 1835)",
    fill: "#4972f4",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6648",
    "data-name": "Mask Group 6648",
    transform: "translate(-316 -1835)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35254",
    "data-name": "Path 35254",
    d: "M21.621,7.953c-.875.68-2.031,1.547-6.016,4.441-.793.578-2.211,1.871-3.605,1.859-1.387.008-2.777-1.258-3.6-1.859C4.414,9.5,3.254,8.637,2.379,7.957A.234.234,0,0,0,2,8.141v7.984A1.875,1.875,0,0,0,3.875,18h16.25A1.875,1.875,0,0,0,22,16.125V8.137A.235.235,0,0,0,21.621,7.953ZM12,13c.906.016,2.211-1.141,2.867-1.617,5.184-3.762,5.578-4.09,6.773-5.027A.935.935,0,0,0,22,5.617V4.875A1.875,1.875,0,0,0,20.125,3H3.875A1.875,1.875,0,0,0,2,4.875v.742a.941.941,0,0,0,.359.738c1.2.934,1.59,1.266,6.773,5.027C9.789,11.859,11.094,13.016,12,13Z",
    transform: "translate(316 1837)",
    fill: "#4972f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.99920e314a51c649cdbbb421f836776c.svg";
export { ForwardRef as ReactComponent };